import api from "@/api";

const SET_CUSTOMER_CARDS = "SET_CUSTOMER_CARDS";

export default {
  namespaced: true,
  state: {
    all: {},
  },
  getters: {
    activeCard: ({ all }) => {
      return Object.values(all).find(card => card.isActive);
    },
  },
  actions: {
    async getCards({ commit }, id) {
      let res = await api.card.all(id);

      commit(SET_CUSTOMER_CARDS, res.data["hydra:member"]);

      return res;
    },
    async lockCard(context, id) {
      return await api.card.lock(id);
    },
    async reportStolenCard(context, id) {
      return await api.card.reportStolen(id);
    },
    async addCard(context, { id, number }) {
      return await api.card.create(id, number);
    },
  },
  mutations: {
    [SET_CUSTOMER_CARDS](state, cards) {
      state.all = {};

      cards.forEach(card => {
        state.all[card.id] = card;
      });
    },
  },
};
